import { PropsWithChildren } from 'react';
import { Checkbox } from '@rootCommon/components';
import './DataListHeaderSelectable.scss';

type Props = {
  selectAllItems: (check: boolean) => void;
  selectedAll: boolean;
};

const DataListHeaderSelectable = ({ children, selectedAll, selectAllItems }: PropsWithChildren<Props>): JSX.Element => (
  <>
    <div className="table__top-item table__select">
      <Checkbox onChangeValue={selectAllItems} value={selectedAll} />
    </div>
    <>{children}</>
  </>
);

export default DataListHeaderSelectable;
